/* eslint-disable @typescript-eslint/no-unsafe-assignment -- TODO: fix unsafe assignment */
import { accordionDetailsClasses, Box, Chip, Tooltip } from "@mui/material";
import {
  CoverageAccordionSection,
  CoveragesAccordion,
  Typography,
} from "@platform/design-system";

const Review = ({
  title,
  sections,
  chip,
}: {
  title: string;
  sections: CoverageAccordionSection[];
  chip?: {
    label: string;
    tooltip?: string;
  };
}): React.JSX.Element => (
  <>
    <Box
      data-testid="review-section"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
        "&:not(:first-of-type)": { mt: 3 },
      }}
    >
      <Typography variant="header-small">
        <strong>{title}</strong>
      </Typography>
      {chip && (
        <Tooltip title={chip.tooltip ?? ""} arrow>
          <Chip variant="outlined" color="brandPrimary" label={chip.label} />
        </Tooltip>
      )}
    </Box>
    <CoveragesAccordion
      headers={["", "Winning Carrier", "Decision"]}
      sections={sections}
      slotProps={{
        container: {
          sx: (theme) => ({
            mt: 2,
            borderRadius: 1,
            border: `1px solid ${theme.palette.divider}`,
            [`& .${accordionDetailsClasses.root}`]: {
              backgroundColor: theme.palette.neutrals.neutral_50,
            },
          }),
        },
      }}
    />
  </>
);

export { Review };
